import { ReactComponent as LogoInverse } from '../../assets/plc_full_logo-cropped-inverse.svg';
import { ReactComponent as Logo } from '../../assets/plc_full_logo-cropped.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDarkMode, useModalToggle } from '../../hooks';
import { appRoutes } from '../../config';
import { ConfirmModal } from '../modals';
import clsx from 'clsx';

import type { FCCN } from '../../types';
import { useContext } from 'react';
import { Localization } from '../../config/localization/localization';
import { LanguageSelectorContext } from '../../context/LanguageSelectorContext';

interface IPLCMenuLinkProps {
    isDisabled?: boolean;
}

export const PLCMenuLink: FCCN<IPLCMenuLinkProps> = ({ isDisabled }) => {
    const { isDarkMode, isLightMode } = useDarkMode();
    const location = useLocation();
    const navigate = useNavigate();

    const confirmNavigateModal = useModalToggle();

    const onDashboard = location.pathname === appRoutes.dashboard;

    const onLogoClick = () => {
        if (isDisabled) return;
        onDashboard ? navigate(appRoutes.dashboard) : confirmNavigateModal.open();
    };

    const onDashboardConfirmed = () => navigate(appRoutes.dashboard);

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    return (
        <>
            {/* PLC LOGO */}
            {!onDashboard && (
                <Link
                    className={clsx(
                        'keyboard-focus ml-1 outline-none sm:w-[250px] md:ml-8',
                        isDisabled ? 'cursor-default' : 'cursor-pointer'
                    )}
                    onClick={(e) => e.preventDefault()}
                    to={appRoutes.dashboard}
                >
                    {isDarkMode && <LogoInverse onClick={onLogoClick} />}
                    {isLightMode && <Logo onClick={onLogoClick} />}
                </Link>
            )}

            {onDashboard && (
                <div className={'ml-1 -mt-1 outline-none xxs:w-[250px] md:ml-8'}>
                    {isDarkMode && <LogoInverse onClick={onLogoClick} />}
                    {isLightMode && <Logo onClick={onLogoClick} />}
                </div>
            )}

            {/* CONFIRM RETURN TO DASHBOARD */}
            <ConfirmModal
                message={localization.translate('menuOptions.dashboardReturnMessage')}
                onConfirm={onDashboardConfirmed}
                modalToggle={confirmNavigateModal}
                title={localization.translate('menuOptions.dashboardReturnTitle')}
            />
        </>
    );
};